import { FC } from 'react';
import Typography from '@ixigo/iui/Typography';
import Chip from '@ixigo/iui/Chip';
import { RequestSection as TimelineSectionType, HistoryItem } from '../timelineTypes';
import TimelineEntry from './TimelineEntry';

type TimelineSectionProps = {
    section: TimelineSectionType;
    onItemClick?: (item: HistoryItem) => void;
};

const TimelineSection: FC<TimelineSectionProps> = ({ section, onItemClick }) => {
    const { title, status, items } = section;
    const chipColor = status === 'resolved' ? 'success' : 'warning';
    const chipText = status === 'resolved' ? 'Resolved' : 'In Progress';

    return (
        <div className='bg-white rounded-20 p-20 border border-gray-300 mb-20'>
            <div className='flex justify-between items-center mb-20'>
                <Typography variant='body-md' fontWeight='medium' className='text-charcoal-800 font-size-14'>
                    {title}
                </Typography>
                <Chip color={chipColor} size='sm' variant='soft'>
                    {chipText}
                </Chip>
            </div>

            <div className='relative'>
                {items.map((item, index) => (
                    <TimelineEntry key={item.id} item={item} index={index} items={items} onClick={onItemClick} />
                ))}
            </div>
        </div>
    );
};

export default TimelineSection;
